import React, {useState} from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'
import {useCookies} from 'react-cookie'
import {useAppSelector} from 'src/hooks'
import {PATHS} from 'src/constants/constants'
import AppShellNew from 'src/components-new/shell/AppShellNew'
import WarningDialogNew from 'src/components-new/feedback/WarningDialogNew'
import {useToast} from 'src/components-new/feedback/ToastProvider'
import {buildNavItems, NEW_PATHS} from './routesMap'
import ContactMeDialogNew from './ContactMeDialogNew'
import HomepageNew from 'src/pages-new/homepage/HomepageNew'
import PerformancesNew from 'src/pages-new/performances/PerformancesNew'
import DocumentsNew from 'src/pages-new/documents/DocumentsNew'
import InfoMaterialsNew from 'src/pages-new/infoMaterials/InfoMaterialsNew'
import MyDocumentsNew from 'src/pages-new/myDocuments/MyDocumentsNew'
import AgendaNew from 'src/pages-new/agenda/AgendaNew'
import PlaceholderPage from 'src/pages-new/PlaceholderPage'
import SummaryNew from 'src/pages-new/summary/SummaryNew'
import SummaryPatientNew from 'src/pages-new/summaryPatient/SummaryPatientNew'
import ProfileNew from 'src/pages-new/profile/ProfileNew'
import PatientsListNew from 'src/pages-new/patients/PatientsListNew'
import PatientDetailNew from 'src/pages-new/patient/PatientDetailNew'
import TherapiesNew from 'src/pages-new/therapies/TherapiesNew'
import VirtualMeetingsListNew from 'src/pages-new/agenda/VirtualMeetingsListNew'
import BiologicalSamplesListNew from 'src/pages-new/biologicalSamples/BiologicalSamplesListNew'
import PatientActivitiesListNew from 'src/pages-new/patientActivities/PatientActivitiesListNew'
import EchocardiographicRequestsListNew from 'src/pages-new/echocardiographicRequests/EchocardiographicRequestsListNew'
import MedicalCentersListNew from 'src/pages-new/medicalCenters/MedicalCentersListNew'
import CustomerUsersListNew from 'src/pages-new/customerUsers/CustomerUsersListNew'
import MaterialRequestsListNew from 'src/pages-new/materialRequests/MaterialRequestsListNew'
import EnrollmentHubNew from 'src/pages-new/enrollmentHub/EnrollmentHubNew'
import CommunicationsListNew from 'src/pages-new/communications/CommunicationsListNew'
import ExportsListNew from 'src/pages-new/exports/ExportsListNew'
import QuestionnairesListNew from 'src/pages-new/questionnaires/QuestionnairesListNew'
import DiaryNew from 'src/pages-new/diary/DiaryNew'
import AnalyticsNew from 'src/pages-new/analytics/AnalyticsNew'
import SecondaryAssumptionResponseNew from 'src/pages-new/secondaryAssumptions/SecondaryAssumptionResponseNew'
import LatestReminderRedirectNew from 'src/pages-new/secondaryAssumptions/LatestReminderRedirectNew'
import {useReminderPush} from 'src/services/push/useReminderPush'
import PushActivationBanner from './PushActivationBanner'

function MainRoutingPagesNew(): JSX.Element {
  const sidebarItems = useAppSelector(state => state.pspConfigReducer.data.sidebarItems)
  const unreadNotificationsCount = useAppSelector(state => state.userReducer.data?.unreadNotificationsCount)
  const userGroup = useAppSelector(state => state.userReducer.data?.userGroup)
  const [cookies, setCookies] = useCookies(['warningDialog'])
  const [contactOpen, setContactOpen] = useState(false)
  const toast = useToast()
  useReminderPush()

  const navItems = buildNavItems(sidebarItems, unreadNotificationsCount, userGroup)
  const navItemsWithActions = navItems.map(item =>
    item.key === 'contact' ? {...item, onClick: () => setContactOpen(true)} : item
  )

  return (
    <AppShellNew navItems={navItemsWithActions}>
      {!cookies.warningDialog && (
        <WarningDialogNew onClose={() => setCookies('warningDialog', true)} />
      )}
      <ContactMeDialogNew
        open={contactOpen}
        onClose={() => setContactOpen(false)}
        onSuccess={() => toast.success('Richiesta di contatto inviata con successo.')}
        onError={() => toast.error("Errore nell'invio della richiesta di contatto.")}
      />
      <PushActivationBanner />
      <Switch>
        {sidebarItems.summaryPatient?.show && (
          <Route component={SummaryPatientNew} exact path={NEW_PATHS.PATIENT_HOME} />
        )}

        {sidebarItems.homepage?.show && (
          <Route component={HomepageNew} exact path={NEW_PATHS.HOMEPAGE} />
        )}
        {sidebarItems.summary?.show && (
          <Route component={SummaryNew} exact path={NEW_PATHS.SUMMARY} />
        )}

        <Route
          path={PATHS.PROFILE}
          render={() => <ProfileNew />}
        />

        {sidebarItems.patients?.show && (
          <Route
            path={PATHS.PATIENT}
            render={() => <PatientDetailNew />}
          />
        )}

        {sidebarItems.patients?.show && (
          <Route
            exact
            path={PATHS.PATIENTS}
            render={() => <PatientsListNew />}
          />
        )}

        {sidebarItems.therapies?.show && (
          <Route
            path={PATHS.THERAPIES}
            render={() => <TherapiesNew />}
          />
        )}

        {sidebarItems.enrollmentHub?.show && (
          <Route
            path={PATHS.ENROLLMENT_HUB}
            render={() => <EnrollmentHubNew />}
          />
        )}

        {sidebarItems.agenda?.show && (
          <Route
            path={PATHS.AGENDA}
            render={() => <AgendaNew />}
          />
        )}

        {sidebarItems.patientActivities?.show && (
          <Route
            path={PATHS.PATIENT_ACTIVITIES}
            render={() => <PatientActivitiesListNew />}
          />
        )}

        {sidebarItems.virtualMeetings?.show && (
          <Route
            path={PATHS.VIRTUAL_MEETINGS}
            render={() => <VirtualMeetingsListNew />}
          />
        )}

        {sidebarItems.infoMaterials?.show && (
          <Route
            path={PATHS.INFO_MATERIALS}
            render={() => <InfoMaterialsNew />}
          />
        )}

        {sidebarItems.documents?.show && (
          <Route
            path={PATHS.DOCUMENTS}
            render={() => <DocumentsNew />}
          />
        )}

        {sidebarItems.myDocuments?.show && (
          <Route
            path={PATHS.MY_DOCUMENTS}
            render={() => <MyDocumentsNew />}
          />
        )}

        {sidebarItems.export?.show && (
          <Route
            path={PATHS.EXPORT}
            render={() => <ExportsListNew />}
          />
        )}

        {sidebarItems.performances?.show && (
          <Route
            path={PATHS.PERFORMANCES}
            render={() => <PerformancesNew />}
          />
        )}

        {sidebarItems.survey?.show && (
          <Route path={PATHS.QUESTIONNAIRE} render={() => <QuestionnairesListNew />} />
        )}

        {sidebarItems.communications?.show && (
          <Route path={PATHS.COMMUNICATIONS} render={() => <CommunicationsListNew />} />
        )}

        {sidebarItems.medicalCenters?.show && (
          <Route path={PATHS.MEDICAL_CENTERS} render={() => <MedicalCentersListNew />} />
        )}

        {sidebarItems.customerUtilities?.show && (
          <Route path={PATHS.CUSTOMER_USERS} render={() => <CustomerUsersListNew />} />
        )}

        {sidebarItems.materialRequests?.show && (
          <Route path={PATHS.MATERIAL_REQUESTS} render={() => <MaterialRequestsListNew />} />
        )}

        {sidebarItems.biologicalSamples?.show && (
          <Route path={PATHS.TEST_DBS} render={() => <BiologicalSamplesListNew />} />
        )}

        {sidebarItems.echocardiographicRequests?.show && (
          <Route path={PATHS.ECHOCARDIOGRAPHIC_REQUESTS} render={() => <EchocardiographicRequestsListNew />} />
        )}

        {sidebarItems.therapyDiary?.show && (
          <Route path={PATHS.DIARY} render={() => <DiaryNew />} />
        )}

        {sidebarItems.analytics?.show && (
          <Route path={PATHS.ANALYTICS} render={() => <AnalyticsNew />} />
        )}

        {/* Non gated da sidebarItems: è la pagina puntata dal link dentro il promemoria di
            assunzione, e chi ci arriva dalla mail/SMS non ha altro contesto che l'id nell'URL.
            Legarla a sidebarItems.secondaryTherapies romperebbe il link proprio sui PSP che
            hanno la voce di menu nascosta pur inviando i promemoria. */}
        <Route
          exact
          path={PATHS.SECONDARY_ASSUMPTION_RESPONSE}
          render={() => <SecondaryAssumptionResponseNew />}
        />

        {/* Click on the web push reminder (public/service-worker.js): not gated either, for the
            same reason as the response page above. */}
        <Route exact path={PATHS.REMINDER} render={() => <LatestReminderRedirectNew />} />

        {/* Non gated da sidebarItems: raggiungibile solo tramite "Vedi tutti" dalla card
            Terapie della homepage (contentType 'therapies' → terapie accessorie), la cui
            visibilità dipende da homepageConfigurations.cards ed è indipendente dal flag
            sidebarItems.secondaryTherapies. */}
        <Route
          path={PATHS.THERAPIES}
          render={() => <PlaceholderPage title={sidebarItems.secondaryTherapies?.label ?? 'Altre terapie'} />}
        />

        <Redirect to={
          sidebarItems.homepage?.show ? NEW_PATHS.HOMEPAGE :
          sidebarItems.summaryPatient?.show ? NEW_PATHS.PATIENT_HOME :
          NEW_PATHS.SUMMARY
        } />
      </Switch>
    </AppShellNew>
  )
}

export default MainRoutingPagesNew
